import { toDate, setDate } from 'date-fns';

import getFeatureDecision from '../../../config';
import { ENABLE_CHEAPEST_DATES } from '../../../config/constants';
import {
  RECEIVE_MONTH_DATA,
  RECEIVE_PRICE_TRACES,
  REQUEST_MONTH_DATA,
  REQUEST_MONTH_DATA_BLOCKED,
  SELECT_MONTH,
} from '../helpers/constants/actionsConstants';
import priceColourCoder from '../helpers/presentation/priceColourCoder';

import type {
  MonthDataAction,
  ReceiveMonthDataStartAction,
  ReceivePriceTracesAction,
} from '../actions/types';
import type { MonthDataState } from '../selectors/types';

const initialState: MonthDataState = {
  monthDataGrid: [[]],
  monthDataUrl: '',
  priceTraces: {},
  priceColourBands: [],
  isLoading: true,
};

const getGrid = (
  grid: MonthDataState['monthDataGrid'],
  outboundMonth?: Date,
): MonthDataState['monthDataGrid'] => {
  const enableCheapestDates = getFeatureDecision(ENABLE_CHEAPEST_DATES, false);

  if (enableCheapestDates && outboundMonth) {
    const updatedGrid = grid.map((inboundDate) =>
      inboundDate.map((entry, index) => {
        if (entry.outboundDayOfWeek === undefined) {
          const monthDate = setDate(toDate(outboundMonth), index + 1);
          const dayOfWeek = monthDate.getDay();
          return {
            ...entry,
            outboundDayOfWeek: dayOfWeek,
          };
        }
        return entry;
      }),
    );
    return updatedGrid;
  }
  return grid;
};

const reduceReceiveMonthData = (
  state: MonthDataState,
  action: ReceiveMonthDataStartAction,
): MonthDataState => {
  const { grid, outboundMonth, url } = action.payload[0];
  const priceColourBands = grid
    ? priceColourCoder.calculateColourBands(grid)
    : [];

  return {
    ...state,
    monthDataGrid: getGrid(grid, outboundMonth),
    monthDataUrl: url,
    priceColourBands,
    isLoading: false,
  };
};

const reduceReceivePriceTraces = (
  state: MonthDataState,
  action: ReceivePriceTracesAction,
): MonthDataState => ({
  ...state,
  priceTraces: action.payload,
});

const reduceStartLoading = (state: MonthDataState): MonthDataState => ({
  ...state,
  monthDataGrid: [[]],
  isLoading: true,
});

const reducer = (
  state: MonthDataState = initialState,
  action: MonthDataAction,
): MonthDataState => {
  switch (action.type) {
    case `${REQUEST_MONTH_DATA}_STARTED`:
    case SELECT_MONTH:
      return reduceStartLoading(state);

    case REQUEST_MONTH_DATA_BLOCKED:
      return { ...state, isLoading: false };

    case `${RECEIVE_MONTH_DATA}_STARTED`:
      return reduceReceiveMonthData(
        state,
        action as ReceiveMonthDataStartAction,
      );

    case RECEIVE_PRICE_TRACES:
      return reduceReceivePriceTraces(state, action);

    default:
      return state;
  }
};

export default reducer;
